import React, { useState } from 'react';

import { Grid2 } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';

function ClientTour() {
  const [open, setOpen] = useState(true);

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <Grid2 container direction="column" style={{ padding: '28px 32px' }}>
        <Grid2 item container direction="column" alignItems="center">
          <Grid2 item>
            <Typography style={{ fontFamily: 'Montserrat', fontWeight: '600' }}>
              Bem vindo(a) ao
            </Typography>
          </Grid2>
          <Grid2 item>
            <img src="/logo-full-color.svg" alt="sioon logo" />
          </Grid2>
        </Grid2>
        <Grid2 item style={{ margin: '32px 0' }}>
          <Typography component="p" variant="body1">
            Acesse agora mesmo a versão desktop e veja o Tour Rápido que
            preparamos para você conhecer todas as funcionalidades nosso
            sistema.
          </Typography>
        </Grid2>
        <Grid2 item container justifyContent="center">
          <Button
            color="primary"
            variant="contained"
            onClick={() => setOpen(false)}
            style={{ width: '90%' }}
          >
            ENTENDI
          </Button>
        </Grid2>
        <Grid2 item style={{ marginTop: '32px' }}>
          <Typography
            component="p"
            variant="body2"
            style={{ fontWeight: '400' }}
          >
            <span style={{ color: '#f64726', fontWeight: '600' }}>
              Importante:
            </span>{' '}
            No momento nosso Tour Rápido está disponível somente na versão
            desktop, acesse pelo computador.
          </Typography>
        </Grid2>
      </Grid2>
    </Dialog>
  );
}

export default ClientTour;
